import slider from './slider';

let tag = document.createElement('script');
tag.id = 'iframe-demo';
tag.src = 'https://www.youtube.com/iframe_api';
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// eslint-disable-next-line no-unused-vars
let player;
// eslint-disable-next-line no-unused-vars
window.onYouTubeIframeAPIReady = function() {
  var elems1 = document.getElementsByClassName('yt-player');
  for(var i = 0; i < elems1.length; i++) {

    // eslint-disable-next-line no-undef
    player = new YT.Player(elems1[i], {
      events: {
        'onStateChange': onPlayerStateChange,
      },
    });
  }
}

function onPlayerStateChange(event) {
  slider.handleVideo(event.data);
}



// WEBPACK FOOTER //
// ./scripts/util/iframe_youtube.js